// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/Payload/BlkArc.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported.Payload";

export interface BlkArc {
  /** Common to all payloads */
  isAvailable: boolean;
  recordingState: BlkArc_State;
}

/** Copied from BLK ARC API v0.9.0 */
export enum BlkArc_State {
  /** BOOTING - The device is booting the operating system and is not yet ready. */
  BOOTING = 0,
  /** OTA_IN_PROGRESS - An Over-the-Air update is ongoing. A capture is not possible in this state. */
  OTA_IN_PROGRESS = 1,
  /** FLASHING_HW_MAIN - The main FPGA is being flashed. Cameras and head assembly are not available during this process. */
  FLASHING_HW_MAIN = 2,
  /** FLASHING_HW_HEAD - The head assembly is being flashed. The head assembly is not available during this process. */
  FLASHING_HW_HEAD = 3,
  /** IDLE - The device is idle and ready to start a capture. */
  IDLE = 4,
  /**
   * CAPTURE_STARTING - A capture is currently initialising.
   * This state begins when the user requests the capture to be started and transitions into `CAPTURE_RUNNING`
   * when the SLAM algorithm has been initialised. If this fails, the device will enter a `FAULT_DEGRADED` or
   * `FAULT_RECOVERABLE_DEGRADED` state.
   */
  CAPTURE_STARTING = 5,
  /** CAPTURE_RUNNING - A capture is ongoing. Use `Capture.GetCaptureStatus` to get more detailed information. */
  CAPTURE_RUNNING = 6,
  /** CAPTURE_RUNNING_STATIC - A capture is running, and the device is in static mode. */
  CAPTURE_RUNNING_STATIC = 12,
  /** CAPTURE_STOPPING - A capture has been given the order to stop and it is finalising, after which, the device will transition into `IDLE`. */
  CAPTURE_STOPPING = 7,
  /**
   * FAULT_BROKEN - The device has experienced a serious fault, likely caused by mechanical issues.
   * Scanning is not possible in this state. A service report should be created and saved using the `Support` service.
   * More information about the fault can be obtained using the `Fault` service. This fault may be recovered with a reboot in some cases.
   */
  FAULT_BROKEN = 8,
  /**
   * FAULT_DEGRADED - The device has experienced a fault, likely caused by components being in an unexpected state.
   * Scanning is not possible in this state. A service report should be created and saved using the `Support` service.
   * More information about the fault can be obtained using the `Fault` service. This fault should be fixed with a reboot.
   */
  FAULT_DEGRADED = 9,
  /**
   * FAULT_RECOVERABLE_DEGRADED - The device has experience a fault that can be recovered without a reboot.
   * This fault needs to be acknowledged using the `Fault` service or with a short button press.
   */
  FAULT_RECOVERABLE_DEGRADED = 10,
  /**
   * SHUTDOWN - The device has been given the order to shut down or reboot and is preparing to do so.
   * If the device is in this state, the client should be ready for the communication to be lost at any point in the near future.
   */
  SHUTDOWN = 11,
  /** SELF_CHECK_RUNNING - Device is running self check and No capture is possible in this state */
  SELF_CHECK_RUNNING = 13,
  /** UNKNOWN - !!! This was added in case the blk arc reports a state that can't be mapped to this enum or no state was recieved */
  UNKNOWN = 99,
  UNRECOGNIZED = -1,
}

export function blkArc_StateFromJSON(object: any): BlkArc_State {
  switch (object) {
    case 0:
    case "BOOTING":
      return BlkArc_State.BOOTING;
    case 1:
    case "OTA_IN_PROGRESS":
      return BlkArc_State.OTA_IN_PROGRESS;
    case 2:
    case "FLASHING_HW_MAIN":
      return BlkArc_State.FLASHING_HW_MAIN;
    case 3:
    case "FLASHING_HW_HEAD":
      return BlkArc_State.FLASHING_HW_HEAD;
    case 4:
    case "IDLE":
      return BlkArc_State.IDLE;
    case 5:
    case "CAPTURE_STARTING":
      return BlkArc_State.CAPTURE_STARTING;
    case 6:
    case "CAPTURE_RUNNING":
      return BlkArc_State.CAPTURE_RUNNING;
    case 12:
    case "CAPTURE_RUNNING_STATIC":
      return BlkArc_State.CAPTURE_RUNNING_STATIC;
    case 7:
    case "CAPTURE_STOPPING":
      return BlkArc_State.CAPTURE_STOPPING;
    case 8:
    case "FAULT_BROKEN":
      return BlkArc_State.FAULT_BROKEN;
    case 9:
    case "FAULT_DEGRADED":
      return BlkArc_State.FAULT_DEGRADED;
    case 10:
    case "FAULT_RECOVERABLE_DEGRADED":
      return BlkArc_State.FAULT_RECOVERABLE_DEGRADED;
    case 11:
    case "SHUTDOWN":
      return BlkArc_State.SHUTDOWN;
    case 13:
    case "SELF_CHECK_RUNNING":
      return BlkArc_State.SELF_CHECK_RUNNING;
    case 99:
    case "UNKNOWN":
      return BlkArc_State.UNKNOWN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BlkArc_State.UNRECOGNIZED;
  }
}

export function blkArc_StateToJSON(object: BlkArc_State): string {
  switch (object) {
    case BlkArc_State.BOOTING:
      return "BOOTING";
    case BlkArc_State.OTA_IN_PROGRESS:
      return "OTA_IN_PROGRESS";
    case BlkArc_State.FLASHING_HW_MAIN:
      return "FLASHING_HW_MAIN";
    case BlkArc_State.FLASHING_HW_HEAD:
      return "FLASHING_HW_HEAD";
    case BlkArc_State.IDLE:
      return "IDLE";
    case BlkArc_State.CAPTURE_STARTING:
      return "CAPTURE_STARTING";
    case BlkArc_State.CAPTURE_RUNNING:
      return "CAPTURE_RUNNING";
    case BlkArc_State.CAPTURE_RUNNING_STATIC:
      return "CAPTURE_RUNNING_STATIC";
    case BlkArc_State.CAPTURE_STOPPING:
      return "CAPTURE_STOPPING";
    case BlkArc_State.FAULT_BROKEN:
      return "FAULT_BROKEN";
    case BlkArc_State.FAULT_DEGRADED:
      return "FAULT_DEGRADED";
    case BlkArc_State.FAULT_RECOVERABLE_DEGRADED:
      return "FAULT_RECOVERABLE_DEGRADED";
    case BlkArc_State.SHUTDOWN:
      return "SHUTDOWN";
    case BlkArc_State.SELF_CHECK_RUNNING:
      return "SELF_CHECK_RUNNING";
    case BlkArc_State.UNKNOWN:
      return "UNKNOWN";
    case BlkArc_State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseBlkArc(): BlkArc {
  return { isAvailable: false, recordingState: 0 };
}

export const BlkArc: MessageFns<BlkArc> = {
  encode(message: BlkArc, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isAvailable !== false) {
      writer.uint32(8).bool(message.isAvailable);
    }
    if (message.recordingState !== 0) {
      writer.uint32(16).int32(message.recordingState);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BlkArc {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlkArc();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isAvailable = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.recordingState = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BlkArc {
    return {
      isAvailable: isSet(object.isAvailable) ? globalThis.Boolean(object.isAvailable) : false,
      recordingState: isSet(object.recordingState) ? blkArc_StateFromJSON(object.recordingState) : 0,
    };
  },

  toJSON(message: BlkArc): unknown {
    const obj: any = {};
    if (message.isAvailable !== false) {
      obj.isAvailable = message.isAvailable;
    }
    if (message.recordingState !== 0) {
      obj.recordingState = blkArc_StateToJSON(message.recordingState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BlkArc>, I>>(base?: I): BlkArc {
    return BlkArc.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BlkArc>, I>>(object: I): BlkArc {
    const message = createBaseBlkArc();
    message.isAvailable = object.isAvailable ?? false;
    message.recordingState = object.recordingState ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
